import { render } from "./CompanyTable.vue?vue&type=template&id=33bc6940&scoped=true"
import script from "./CompanyTable.vue?vue&type=script&lang=js"
export * from "./CompanyTable.vue?vue&type=script&lang=js"

import "./CompanyTable.vue?vue&type=style&index=0&id=33bc6940&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc6940"]])

export default __exports__